import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpRequestInterceptor } from './httpReq.interceptor';
// import { LoggingInterceptor } from './logging.interceptor';


/** Array of Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
//   { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true }
];